import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useSubscription } from "../hooks/useSubscription";
import { resolveEffectiveAuthUser } from "../lib/resolveEffectiveAuthUser";

const ProtectedRoute = ({ allowedRoles = [], allowedPermissions = [] }) => {
  const { userProfile: authUser, profileLoading, loading } = useAuth();
  const location = useLocation();

  const effectiveUser = resolveEffectiveAuthUser(authUser);
  const userRoles = effectiveUser?.roleTypes ?? [];

  const isDentistClient = userRoles.includes('dentist_client');
  const isPackUserPage = location.pathname === '/pack-user';

  const { isLoading: packLoading } = useSubscription(
    isDentistClient && !isPackUserPage ? effectiveUser?.id : null
  );

  if (loading || profileLoading || (isDentistClient && !isPackUserPage && packLoading)) {
    return (
      <div style={styles.center}>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={styles.spinner} />
        <p style={styles.loadingText}>Vérification des permissions…</p>
      </div>
    );
  }

  if (!effectiveUser) {
    return <Navigate to="/login" replace />;
  }

  const permissionCodes = effectiveUser.permissionCodes ?? [];

  const hasNoRoles = userRoles.length === 0;
  const roleGateActive = allowedRoles.length > 0;
  const permGateActive = Array.isArray(allowedPermissions) && allowedPermissions.length > 0;
  const passesRole = roleGateActive && allowedRoles.some((r) => userRoles.includes(r));
  const passesPerm =
    permGateActive &&
    permissionCodes.some((c) =>
      typeof c === 'string' ? allowedPermissions.includes(c.trim()) : false,
    );

  if (!roleGateActive && !permGateActive) {
    if (hasNoRoles) {
      return <Navigate to="/unauthorized" replace />;
    }
    return <Outlet />;
  }

  if (!(passesRole || passesPerm)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

const styles = {
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "#0f172a",
  },
  spinner: {
    width: 40,
    height: 40,
    border: "4px solid #334155",
    borderTop: "4px solid #38bdf8",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
  },
  loadingText: {
    color: "#94a3b8",
    marginTop: 16,
    fontFamily: "sans-serif",
    fontSize: 14,
  },
};

export default ProtectedRoute;
